export const PAGE_RENDERER_CONSTANTS = {
    /**
     * Must be applied to all the horizontal headers on the page.
     * This can be used to measure the height of the viewport excluding
     * the headers.
     * Added to support the "FULL_HEIGHT" option in the table height settings.
     */
    HORIZONTAL_HEADER_CLASS_NAME: "spr-horizontal-header",
} as const;
